import React, { useState, useEffect } from 'react';
import { useGradeFilterStore } from '../../store/gradeFilterStore';
import { useShallow } from 'zustand/react/shallow';
import './BlockModelLegend.css';

const BlockModelLegend = ({ isVisible }) => {
  const [minimized, setMinimized] = useState(false);

  const { enabledRanges, toggleRange, setAllRanges } = useGradeFilterStore(
    useShallow((state) => ({
      enabledRanges: state.enabledRanges,
      toggleRange: state.toggleRange,
      setAllRanges: state.setAllRanges,
    }))
  );

  // Color ranges matching BlockModels.js
  const colorRanges = [
    { min: 2, max: null, color: '#ff0000', label: '2+', rangeKey: 'range0' },
    { min: 1.5, max: 2, color: '#ffff00', label: '1.5 - 2', rangeKey: 'range1' },
    { min: 1, max: 1.5, color: '#00ff00', label: '1 - 1.5', rangeKey: 'range2' },
    { min: 0.6, max: 1, color: '#87CEEB', label: '0.6 - 1', rangeKey: 'range3' },
    { min: 0, max: 0.6, color: '#0000ff', label: '0 - 0.6', rangeKey: 'range4' },
  ];

  const allEnabled = Object.values(enabledRanges).every(v => v);
  const allDisabled = Object.values(enabledRanges).every(v => !v);

  if (!isVisible) return null;

  return (
    <div className={`block-model-legend ${minimized ? 'minimized' : ''}`}>
      <div className="legend-header">
        <h3 className="legend-title">Grade Legend</h3>
        <button
          className="legend-toggle-btn"
          onClick={() => setMinimized(!minimized)}
          title={minimized ? 'Expand' : 'Minimize'}
        >
          {minimized ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 18 18" fill="none">
              <path d="M16.875 7.875H10.125V1.125C10.125 0.826631 10.0065 0.540484 9.79549 0.329505C9.58452 0.118527 9.29837 0 9 0C8.70163 0 8.41548 0.118527 8.20451 0.329505C7.99353 0.540484 7.875 0.826631 7.875 1.125V7.875H1.125C0.826631 7.875 0.540484 7.99353 0.329505 8.20451C0.118527 8.41548 0 8.70163 0 9C0 9.29837 0.118527 9.58452 0.329505 9.79549C0.540484 10.0065 0.826631 10.125 1.125 10.125H7.875V16.875C7.875 17.1734 7.99353 17.4595 8.20451 17.6705C8.41548 17.8815 8.70163 18 9 18C9.29837 18 9.58452 17.8815 9.79549 17.6705C10.0065 17.4595 10.125 17.1734 10.125 16.875V10.125H16.875C17.1734 10.125 17.4595 10.0065 17.6705 9.79549C17.8815 9.58452 18 9.29837 18 9C18 8.70163 17.8815 8.41548 17.6705 8.20451C17.4595 7.99353 17.1734 7.875 16.875 7.875Z" fill="#333333"/>
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 18 18" fill="none">
              <path d="M16.875 7.875H1.125C0.826631 7.875 0.540484 7.99353 0.329505 8.20451C0.118527 8.41548 0 8.70163 0 9C0 9.29837 0.118527 9.58452 0.329505 9.79549C0.540484 10.0065 0.826631 10.125 1.125 10.125H16.875C17.1734 10.125 17.4595 10.0065 17.6705 9.79549C17.8815 9.58452 18 9.29837 18 9C18 8.70163 17.8815 8.41548 17.6705 8.20451C17.4595 7.99353 17.1734 7.875 16.875 7.875Z" fill="#333333"/>
            </svg>
          )}
        </button>
      </div>
      {!minimized && (
        <div className="legend-content">
          {/* Select All / Deselect All button */}
          <div className="legend-controls">
            <button
              className="legend-select-all-btn"
              onClick={() => setAllRanges(!allEnabled)}
            >
              {allEnabled ? 'Deselect All' : 'Select All'}
            </button>
          </div>
          {colorRanges.map((range, index) => (
            <div key={index} className="legend-item">
              <input
                type="checkbox"
                checked={enabledRanges[range.rangeKey]}
                onChange={() => toggleRange(range.rangeKey)}
                className="legend-checkbox"
                id={`range-${index}`}
              />
              <label htmlFor={`range-${index}`} className="legend-item-label">
                <div
                  className="legend-color-box"
                  style={{ backgroundColor: range.color }}
                />
                <span className="legend-label">{range.label}</span>
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BlockModelLegend;

